import styled from 'styled-components';
import {
  TextArea as SemanticTextArea,
  Form as SemanticForm,
} from 'semantic-ui-react';

const Form = styled(SemanticForm)``;

const FormField = styled(Form.Field)``;

const TextArea = styled(SemanticTextArea)``;

export {
  Form,
  TextArea,
  FormField,
};
